<button mat-button *ngIf="isLoading" disabled="true">
	<mat-icon>
		<mat-spinner diameter="20"> </mat-spinner>
	</mat-icon>
	Loading
</button>
<span style="position:absolute;right:40px;margin-top:30px;">
	<button class="close-button" mat-mini-fab [mat-dialog-close]="true" *ngIf="!isLoading">
		<mat-icon>close</mat-icon>
	</button>
</span>
<div mat-dialog-title class="minus-mat-dialog-title-margin" *ngIf="!isLoading">
	<h1>{{(searchResultDataSource ?
		(searchResultDataSource.filteredData.length < results.length ? searchResultDataSource.filteredData.length + '/'
			: '' ) : '' ) + results.length}} Children </h1>
			<hr />
			<h4>
				<div class="margin-vertical-md">
					<div>
						Grade: {{data.GRADES}}
					</div>
					<div *ngIf="data.AGE !== 'Total For Grade'">
						Age on 9/1/{{data.schoolYear.substring(0, 4)}}: {{data.AGE}}
					</div>
				</div>

				<div class="row">
					<mat-form-field>
						<mat-label>
							Filter
						</mat-label>
						<input matInput id="filter" name="filter" type="string" [(ngModel)]="searchResultFilter"
							(ngModelChangeDebounced)="setFilter(searchResultDataSource, searchResultFilter)" />
					</mat-form-field>
				</div>
			</h4>
</div>
<mat-dialog-content *ngIf="!isLoading">
	<div class="margin-top-sm table-responsive">
		<mat-table [dataSource]="searchResultDataSource" class="mat-elevation-z1" matSort>

			<ng-container matColumnDef="MSD_NUMBER">
				<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<edit-child-modal-btn [studentId]="element.ID" [type]="'string'" [displayText]="element.MSD_NUMBER">
					</edit-child-modal-btn>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SSID">
				<mat-header-cell *matHeaderCellDef mat-sort-header> SSID </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.SSID}}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="PERSON.LAST_NAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.PERSON.LAST_NAME |
					titlecase}}{{(element.SECOND_LAST_NAME
					? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}}
					{{element.PERSON.FIRST_NAME |
					titlecase}}
					{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="DOB">
				<mat-header-cell *matHeaderCellDef mat-sort-header> DOB </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.DOB | simpleDate}}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="AGE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Age </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.AGE}}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Date </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE |
					simpleDate}}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].SOURCE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Source </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.SCHOOL_ENROLLMENT_DETAILS[0].SOURCE}}
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: displayedColumns;"
				[ngClass]="{'terminatedRow': row.STUDENT_TERMINATION_STATUSES?.length > 0 && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
				[matTooltip]="row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE"
				[matTooltipPosition]="'above'"
				[matTooltipDisabled]="row.STUDENT_TERMINATION_STATUSES?.length === 0 || (row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
				[matTooltipClass]="'terminatedTooltip'">
			</mat-row>
		</mat-table>
	</div>

</mat-dialog-content>
<div mat-dialog-actions class="pull-right" *ngIf="!isLoading">
	<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
		aria-label="Select page of periodic elements">
	</mat-paginator>
</div>